import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Modal,
    Typography,
    Button,
    Select,
    DatePicker,
    notification,
    Input,
    Avatar,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import CleaningTraceabilityApi from "../../Apis/CleaningTraceabilityApi";
import UserApi from "../../Apis/UserApi";
import DepartmentDropdown from "../../DropDowns/Department";
import CleaningTraceabilityItemDrop from "../../DropDowns/CleaningTraceabilityItemDrop";
import AreaDropdown from "../../DropDowns/AreasDropdown";
import DepartmentWithAreaDropdown from "../../DropDowns/DepartmentWithAreaDropdown";

const { Title } = Typography;
const { TextArea } = Input;

function WeeklyCleaning({ visible, onClose, editData, isEditMode = false }) {
    const [formAdd] = Form.useForm();
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const [loading, setLoading] = useState(false);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
    const [selectedDayOfWeek, setSelectedDayOfWeek] = useState(null);

    const {
        control,
        formState: { errors, isSubmitSuccessful },
    } = useForm();

    const UsertenantId = localStorage.getItem("UsertenantId");
    const [TenantUsers, setTenantUsers] = React.useState([]);
    
    const getTenantUsers = useCallback(() => {
        UserApi.tenantUsers(UsertenantId)
            .then((response) => {
                setTenantUsers(response?.payloadDto?.filter(item => (item?.firstName)));
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        getTenantUsers();
    }, [getTenantUsers]);

    // Pre-fill form when in edit mode and editData is provided
    useEffect(() => {
        if (visible && isEditMode && editData) {
            // Set the selected department ID first
            const departmentId = editData?.institutionDTO?.id;
            setSelectedDepartmentId(departmentId);
            setSelectedDayOfWeek(editData?.assignedDayOfWeek);
            
            // Set form values
            formAdd.setFieldsValue({
                taskName: editData?.taskName,
                description: editData?.description,
                institutionId: departmentId,
                areaId: editData?.areaDTO?.id,
                assignedDayOfWeek: editData?.assignedDayOfWeek,
            });
        }
    }, [visible, isEditMode, editData, formAdd]);

    // Reset form when modal is closed
    useEffect(() => {
        if (!visible) {
            formAdd.resetFields();
            setSelectedDepartmentId(null);
            setSelectedDayOfWeek(null);
        }
    }, [visible, formAdd]);

    const handleSubmit = (data) => {
        setLoading(true);
        
        let formData = JSON.stringify({
            taskName: data.taskName,
            frequency: 'WEEKLY',
            assignedDayOfWeek: data.assignedDayOfWeek,
            assignedDateOfMonth: null,
            assignedRole: "",
            description: data.description,
            institutionDTO: {
                id: data.institutionId,
            },
            areaDTO: {
                id: data.areaId,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
            },
            isActive: true,
        });

        const apiCall = isEditMode && editData
            ? CleaningTraceabilityApi.UpdateCleaningTraceability(editData.id, formData)
            : CleaningTraceabilityApi.CreateCleaningTraceability(formData);

        apiCall
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>{isEditMode ? "Updated" : "Created"}</span>,
                    description: `${isEditMode ? "Updated" : "Created"} Successfully`,
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setLoading(false);
                onClose(true); // Pass true to indicate success and trigger refresh
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                if (err.apiError?.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };

    const currentDate = moment().format("DD/MM/YYYY");

    const handleCancel = () => {
        formAdd.resetFields();
        setSelectedDepartmentId(null);
        setSelectedDayOfWeek(null);
        onClose(false);
    };

    // Day of week options
    const dayOfWeekOptions = [
        { value: "SUNDAY", label: "Sunday" },
        { value: "MONDAY", label: "Monday" },
        { value: "TUESDAY", label: "Tuesday" },
        { value: "WEDNESDAY", label: "Wednesday" },
        { value: "THURSDAY", label: "Thursday" },
        { value: "FRIDAY", label: "Friday" },
        { value: "SATURDAY", label: "Saturday" },
    ];

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                confirmLoading={loading}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    {isEditMode ? "Edit Weekly Task" : "Weekly Task"}
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        {!isEditMode && (
                            <div className="Product-createDate">
                                <div className="mb-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                    <b className="mx-2">{currentDate}</b>
                                    <img
                                        src="/assest/Images/cal.png"
                                        style={{ width: '32px' }}
                                        className="logo-png"
                                        alt="calendar"
                                    />
                                </div>
                                <Form.Item
                                    name="createDate"
                                    initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                    className="text-lable col-lg-5 col-sm-12 col-md-7 disabled d-none"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter Date.",
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        format={"DD/MM/YYYY"}
                                        disabled
                                        className="form-control control-input"
                                    />
                                </Form.Item>
                            </div>
                        )}

                        <Form.Item
                            name="taskName"
                            label="Task Name"
                            className="text-lable producectCol"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter task name.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                placeholder="Task name"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="assignedDayOfWeek"
                            label="Day of Week"
                            className="text-lable producectCol"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select day of week.",
                                },
                            ]}
                        >
                            <Select
                                className="control-Select mb-1"
                                placeholder="Select Day of Week"
                                options={dayOfWeekOptions}
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                        <DepartmentWithAreaDropdown 
                            form={formAdd} 
                            initialDepartmentId={selectedDepartmentId}
                            initialAreaId={editData?.areaDTO?.id}
                        />

                        <Form.Item
                            name="description"
                            label="Description"
                            className="text-lable producectCol"
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter description.",
                                },
                            ]}
                        >
                            <TextArea
                                rows={4}
                                placeholder="Please enter task description..."
                                className="control-input"
                                maxLength={500}
                                showCount
                                style={{ resize: 'vertical' }}
                            />
                        </Form.Item>

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                                padding: "16px 24px 0",
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                {isEditMode ? "Update" : "Create"}
                            </Button>

                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default WeeklyCleaning;